import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  // Lovable email routes authenticate themselves — never wrap/redirect them.
  if (request && new URL(request.url).pathname.startsWith("/lovable/")) {
    return next();
  }
  try {

    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  // No server function uses requireSupabaseAuth (all backend writes go through
  // the admin client), so the Supabase bearer-token attacher is intentionally
  // omitted — including it pulls the whole auth client into the browser bundle.
  // Re-add attachSupabaseAuth here if an authenticated server function is added.
  requestMiddleware: [errorMiddleware],
}));
